import React from 'react'

import * as s from './ControlsGroup.module.scss'

interface IControlsGroupProps {
  children: React.ReactNode
}

const ControlsGroup: React.FC<IControlsGroupProps> = ({ children }) => (
  <div className={s.root} onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}>
    {children}
  </div>
)

export default ControlsGroup
